import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('SocialPage').create(() => ({
  tabsWrapper: {
    width: '100%',
    position: 'absolute',
    padding: '0px 12px',
    left: '0',
    zIndex: '10',
    bottom: 'calc(10vh + 2px)',
  },
}))
